module.exports = __webpack_public_path__ + "static/img/walsh-joey.355dace.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/walsh-joey.jpg
// module id = 3NS2
// module chunks = 0